import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'styled-components';
import { filterProps } from '../../../utils/filterProps';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledGrid = styled.div.withConfig({
  displayName: "Grid__StyledGrid",
  componentId: "zx92xm-0"
})(props => {
  const theme = props.theme;
  return {
    boxSizing: 'border-box',
    display: 'flex',
    flexWrap: 'wrap',
    marginInlineStart: `-${theme.space[400]}`,
    marginInlineEnd: `-${theme.space[400]}`
  };
});
export const Grid = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps
  } = filterProps(rest);
  return /*#__PURE__*/_jsx(StyledGrid, Object.assign({}, domProps, {
    children: children
  }));
};